<template>
  <div
    class="editor_all_logs"
    @click.stop='preventTarget()'
  >
    <div class="take_back">
      <div
        class="hide_logs_button"
        @click.stop='tackBackOperateLogs(false)'
      >
        <span class="el-icon-arrow-right"></span>
      </div>
      <div
        :key="item.path"
        v-for="(item,index) in tabData"
        v-if='item.isShow'
        class="tabck_back_icon"
        :class="[item.path === activeLogName ? 'tabck_back_icon_active':'',item.path === 'sortForm'?'tabck_back_srotform':'']"
        @click.stop='getCurrentActivelog(item)'
      >
        <span
          :class="['iconfont',item.icon]"
          style="font-size:22px;"
        ></span>
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="editor_logs">
      <div class="editor_logs_content">
        <operatelogs v-show="activeLogName === 'operateLog'"></operatelogs>
        <auditlogs v-show="activeLogName === 'auditLog'"></auditlogs>
        <sortform v-show="activeLogName === 'sortForm'"></sortform>
        <newstopic
          v-show="activeLogName === 'newsTopic'"
          :isCanInsert='isCanInsert'
        ></newstopic>
        <comment v-show="activeLogName === 'comment'"></comment>
        <editorhistory v-show="activeLogName === 'editorHistory'"></editorhistory>
        <relatedmatter
          v-show="activeLogName === 'relatedMatter'"
          :isCanInsert='isCanInsert'
        ></relatedmatter>
      </div>

    </div>

  </div>

</template>

<script>
import { getUrlCode } from '../../utils/index.js'
import * as api from '../../api'
import operatelogs from '../commons/logs/operatelogs'
import auditlogs from '../commons/logs/auditlogs'
import newstopic from '../commons/logs/newstopic'
import sortform from '../commons/logs/sortform'
import comment from '../commons/logs/comment'
import editorhistory from '../commons/logs/editorhistory'
import relatedmatter from '../commons/logs/relatedmatter'
export default {
  name: 'everylogs',
  data () {
    return {
      activeLogName: 'editorHistory',
      stretch: true,
      showSuo: true,
      tabData: [{ name: '编辑历史', path: 'editorHistory', isShow: true, icon: 'icon-lishi' }, { name: '操作日志', path: 'operateLog', isShow: true, icon: 'icon-rizhi1' }, { name: '审核日志', path: 'auditLog', isShow: true, icon: 'icon-shenherizhi' }, { name: '关联素材', path: 'relatedMatter', isShow: true, icon: 'icon-sucai' }, { name: '评论', path: 'comment', isShow: true, icon: 'icon-pinglun' }, { name: '串联单', path: 'sortForm', isShow: false, icon: 'icon-chuanliandan-' }, { name: '选题', path: 'newsTopic', isShow: false, icon: 'icon-xuantishenhe' }],

    }
  },
  props: {
    isCanInsert: {
      type: Boolean,
      required: true
    },
    showOuterLock: {
      type: Boolean,
      required: true
    }
  },
  created () {

  },
  components: {
    operatelogs,
    auditlogs,
    sortform,
    newstopic,
    comment,
    editorhistory,
    relatedmatter
  },
  computed: {

  },
  mounted () {
    this.$root.eventHub.$on('setCurrentActiveLogName', (data) => {
      this.activeLogName = data
    })

  },
  destroyed () {
    this.$root.eventHub.$off('setCurrentActiveLogName')
  },
  methods: {
    tackBackOperateLogs (value) {
      this.$emit('tackBackOperateLogs', value)
    },
    changeTabDataRole (obj) {
      if (obj && obj.flag_sys_source && (obj.flag_sys_source == "news_recover" || obj.flag_sys_source == "news_topic")) {
        for (var i = 0; i < this.tabData.length; i++) {
          if (this.tabData[i].path === 'newsTopic') {
            this.tabData[i].isShow = true
            break;
          }
        }
      } else {
        for (var i = 0; i < this.tabData.length; i++) {
          if (this.tabData[i].path === 'newsTopic') {
            this.tabData[i].isShow = false
            break;
          }
        }
      }
      if (obj && obj.sort_form_status && obj.sort_form_status == "yes") {
        for (var j = 0; j < this.tabData.length; j++) {
          if (this.tabData[j].path === 'sortForm') {
            this.tabData[j].isShow = true
            break;
          }
        }
      } else {
        for (var j = 0; j < this.tabData.length; j++) {
          if (this.tabData[j].path === 'sortForm') {
            this.tabData[j].isShow = false
            break;
          }
        }
      }
      if (obj.doc_type === 'picture') {
        this.tabData[0].isShow = false
        this.activeLogName = 'operateLog'
      } else {
        this.tabData[0].isShow = true
        this.activeLogName = 'editorHistory'
      }
    },
    lockLogs () {
      this.showSuo = !this.showSuo
    },
    lockLogsShow () {
      this.showSuo = true
    },
    preventTarget () {

    },
    getCurrentActivelog (item) {
      this.activeLogName = item.path
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.editor_all_logs
  all-length()
  position relative
  display flex

  .take_back
    position relative
    display flex
    flex-direction column
    justify-content center
    align-items center
    width 60px
    height 100%
    background none !important

    .hide_logs_button
      width 60px
      height 60px
      background #ccc
      box-shadow -1px 0px 4px 0px rgba(0, 0, 0, 0.2)
      color #fff
      text-align center
      font-size 26px
      line-height 60px
      cursor pointer

      &:hover
        background #666

    .tabck_back_icon
      position relative
      display flex
      flex-direction column
      justify-content center
      align-items center
      width 60px
      height 60px
      border-bottom 1px solid #D8E2FF
      background #F2F6FF
      box-shadow none
      box-shadow -1px 0px 4px 0px rgba(0, 0, 0, 0.2)
      color #688eff
      text-align center
      letter-spacing 0px
      font-size 12px
      cursor pointer

      .suo
        position absolute
        top -60px
        left 6px

        span
          color #688EFF
          font-size 20px

      &:hover
        background #688EFF
        color #fff

        .suo
          span
            color #606266

    .tabck_back_icon_active
      background #688EFF
      color #fff

    .tabck_back_srotform
      letter-spacing 0px

  .editor_logs
    width 440px
    height 100%
    background #fff

    .editor_logs_title
      height 50px

    .editor_logs_content
      height calc(100% - 10px)
</style>
